import type { MantineTheme } from '@mantine/core';
import { createStyles, Flex, Group, Skeleton, Stack } from '@mantine/core';
import { IconSkeleton } from '@repo/foundations';
import { memo } from 'react';

const useStyles = createStyles((theme) => ({
	inboxPageStack: {
		height: '100%',
		borderTopWidth: 1,
		borderTopStyle: 'solid',
		borderTopColor: theme.other.getColor('border/secondary/default'),
	},
}));

function SkeletonListItem(theme: MantineTheme) {
	return (
		<Flex gap="sm" align="center" mb="md">
			<Skeleton w={28} h={28} sx={{ borderRadius: '50%', flexShrink: 0 }} />
			<Stack spacing={theme.spacing.xs} w="100%">
				<Skeleton w="100%" h={theme.spacing.xs} />
				<Skeleton w="100%" h={theme.spacing.xs} />
			</Stack>
		</Flex>
	);
}

export const InboxSkeleton = memo(() => {
	const { classes, theme } = useStyles();

	return (
		<Stack className={classes.inboxPageStack} spacing={0}>
			<Group p="md" noWrap style={{ height: '100%' }}>
				<Stack w="100%" h="100%" maw={330}>
					<Flex align="start" justify="space-between" mb="md">
						<Flex gap="xs">
							<Skeleton w={36} h={28} />
							<IconSkeleton size={28} />
						</Flex>
						<Flex gap="xs">
							<IconSkeleton size={28} />
							<IconSkeleton size={28} />
						</Flex>
					</Flex>
					{Array.from({ length: 12 }).map((_, index) => (
						<div key={index}>{SkeletonListItem(theme)}</div>
					))}
				</Stack>
				<Skeleton w={1} h="100%" />
				<Stack w="100%" align="center" justify="center">
					<IconSkeleton size={28} />
					<Skeleton mt="lg" width={160} height={theme.spacing.xs} />
				</Stack>
			</Group>
		</Stack>
	);
});
